// ============================================================
// Dark Mode Toggle — FEHN & Kollegen
// ============================================================
// Reads & persists the user's preference in localStorage.
// Respects the OS-level prefers-color-scheme as default.
// Toggles data-theme="dark" on <html>.
//
// The toggle button should have the class .darkmode-toggle
// and contain two Font Awesome icon elements:
//
// Example markup (place in the footer .footer_right div via CMS):
//   <div class="darkmode-toggle noprint">
//     <a aria-label="Farbmodus umschalten" href="#">
//       <i class="fa fa-moon-o"></i>
//       <i class="fa fa-sun-o"></i>
//     </a>
//   </div>
// ============================================================

(function () {
  'use strict';

  var STORAGE_KEY = 'fehn-theme';
  var DARK = 'dark';
  var LIGHT = 'light';

  /**
   * Detect the user's preferred theme:
   * 1. Stored value in localStorage (explicit choice)
   * 2. OS-level prefers-color-scheme
   * 3. Fall back to light
   */
  function getPreferredTheme() {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored === DARK || stored === LIGHT) {
      return stored;
    }
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return DARK;
    }
    return LIGHT;
  }

  /** Apply the theme to the <html> element */
  function applyTheme(theme) {
    if (theme === DARK) {
      document.documentElement.setAttribute('data-theme', DARK);
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }

  /** Toggle between light and dark */
  function toggleTheme(e) {
    e.preventDefault();
    var current = document.documentElement.getAttribute('data-theme') === DARK ? DARK : LIGHT;
    var next = current === DARK ? LIGHT : DARK;
    applyTheme(next);
    localStorage.setItem(STORAGE_KEY, next);
  }

  // ---- Init ----

  // Apply immediately (before DOMContentLoaded) to avoid flash
  applyTheme(getPreferredTheme());

  // Bind click handlers once the DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.darkmode-toggle');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', toggleTheme);
      // Also bind any <a> inside for CMS markup
      var links = buttons[i].querySelectorAll('a');
      for (var j = 0; j < links.length; j++) {
        links[j].addEventListener('click', toggleTheme);
      }
    }
  });

  // Listen for OS-level theme changes (only if user hasn't made an explicit choice)
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
      if (!localStorage.getItem(STORAGE_KEY)) {
        applyTheme(e.matches ? DARK : LIGHT);
      }
    });
  }
})();
